import * as React from 'react';
import { Component } from 'react';
import { computed } from 'mobx';
import { observer } from 'mobx-react';
import styled, { withTheme } from 'styled-components';
import { propStyles } from '@kurtosys/ksys-portal-components/build/utils/propStyles';
import Translate from './Translate';
import DocumentMenu from './Document/DocumentMenu';
import Icon from './Icon';
import HTag from './HTag';
import DynamicLink from './DynamicLink';
import { camelCase } from '@kurtosys/ksys-app-template/dist/utils/changeCase';

const KeyDocumentsWrapper = styled<any, any>('div')`
    ${propStyles};
`;

KeyDocumentsWrapper.defaultProps = {
    margin: '0 0 24px 0',
};

const KeyDocumentsList = styled<any, any>('ul')`
    ${propStyles};
`;

KeyDocumentsList.defaultProps = {
    listStyle: 'none',
    marginY: 'sm',
};

const KeyDocumentsListItem = styled<any, any>('li')`
    ${propStyles};
`;

KeyDocumentsListItem.defaultProps = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingY: 'sm',
    borderWidth: '1px',
    borderStyle: 'none none solid none',
    borderColor: 'gray300',
};

const keyDocumentsLinkDefaultProps = {
    display: 'block',
    marginY: 'md',
    color: 'link',
    fontFamily: 'heading',
    fontWeight: 'bold',
    fontSize: 'xs',
    hover: {
        color: 'linkHover',
    },
};

@observer
class KeyDocuments extends Component<any, any> {
    @computed
    get documentsLinkLabel() {
        const { linkLabel } = this.props.keyDocumentsConfig;
        return linkLabel;
    }

    getDocuments = keyDocuments => {
        const { keyDocumentsConfig } = this.props;
        const {
            showSingleDocument = false,
            showSingleDocumentLabel = false,
            showSingleDocumentGroupLabel = true,
            showIcon,
        } = keyDocumentsConfig;
        const { documents, documentGroupName } = keyDocuments;
        // explicit check to deal with undefined and default to show
        const showDocumentIcon = showIcon !== false;
        return (
            <DocumentMenu
                documents={documents}
                documentGroupLabel={documentGroupName}
                showSingleDocument={showSingleDocument}
                showSingleDocumentLabel={showSingleDocumentLabel}
                showSingleDocumentGroupLabel={showSingleDocumentGroupLabel}
                metricContext={`keyDocuments-${camelCase(documentGroupName)}`}
            >
                {showDocumentIcon && (
                    <Icon
                        fileName="DocumentIcon"
                        height="1.4em"
                        width="1.4em"
                    />
                )}
            </DocumentMenu>
        );
    };

    render() {
        const {
            theme,
            keyDocumentsConfig,
            keyDocuments,
            showHeading,
            queryContext,
            shareClass,
        } = this.props;
        const { documentsLinkLabel } = this;

        return (
            <KeyDocumentsWrapper {...theme.KeyDocumentsWrapper}>
                {showHeading && (
                    <HTag
                        componentTheme={'KeyDocumentsHeading'}
                        defaultStyleProps={{
                            color: 'body',
                            fontFamily: 'heading',
                            fontWeight: 'bold',
                            fontSize: 'md',
                        }}
                        level={2}
                        text={keyDocumentsConfig.label}
                    />
                )}
                <KeyDocumentsList {...theme.KeyDocumentsList}>
                    {keyDocuments.map(keyDocument => (
                        <KeyDocumentsListItem
                            key={keyDocument.documentGroupName}
                            {...theme.KeyDocumentsListItem}
                        >
                            {this.getDocuments(keyDocument)}
                        </KeyDocumentsListItem>
                    ))}
                </KeyDocumentsList>
                {documentsLinkLabel && (
                    <DynamicLink
                        config={keyDocumentsConfig}
                        shareClass={shareClass}
                        queryContext={queryContext}
                        metricContext={`keyDocuments-${camelCase(
                            shareClass.clientCode
                        )}`}
                        ariaLabelKey={'keyDocumentsLink'}
                        {...keyDocumentsLinkDefaultProps}
                        {...theme.FundCardLink}
                    >
                        <Translate>{documentsLinkLabel}</Translate>
                    </DynamicLink>
                )}
            </KeyDocumentsWrapper>
        );
    }
}

export default withTheme(KeyDocuments) as any;



// WEBPACK FOOTER //
// ./src/Components/KeyDocuments.tsx